import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Auth } from '@angular/fire/auth';

@Component({
   selector: 'login-link',
   standalone: true,
   imports: [RouterLink, TranslateModule],
   templateUrl: './login-link.component.html',
   styleUrl: './login-link.component.scss',
})
export class LoginLinkComponent {
   @Input() login: boolean = true;

   constructor(private auth: Auth) {}

   logout() {
      this.auth.signOut();
   }
}
